import React from 'react';
import * as ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router-dom';
import router from './router';

import './assets/js/jquery.min.js';
import './assets/js/component/ui-script.js';

import './assets/css/style.css';
import './assets/css/style2.css';
import './assets/scss/style.scss';

const client = new QueryClient();

const container = document.getElementById('root');
const root = ReactDOM.createRoot(container);

const ROUTER_FLAGS = {
  v7_startTransition: true,
  v7_relativeSplatPath: true,
  v7_fetcherPersist: true,
  v7_normalizeFormMethod: true,
  v7_skipActionErrorRevalidation: true,
  v7_partialHydration: true,
  v7_prependBasename: true,
};

root.render(
  <QueryClientProvider client={client}>
    <RouterProvider router={router} future={ROUTER_FLAGS} />
  </QueryClientProvider>
);
